export async function affShipmentsGetProductsByOrderUseCase(id, shipmentRepository) {

    const result = await shipmentRepository.aff_get_products_by_order(id);
    
    const entity = new shipmentRepository.model_aff_products_by_order(result.data.data);

    if (!entity.isValid()) {
        console.log(entity)
        throw new Error("Shipments Aff get products by order Inválido");
    }
    
    return result.data.data;
}